import { h, render } from 'preact';
import MarkersToolsControl from './markers-tools-control/markers-tools-control';
import MarkersToolsControlMobile from './markers-tools-control-mobile';
import { isMobile } from 'mobile-device-detect';

export function renderMarkersToolsControl( map, 
                                            markersService, 
                                            routesService,
                                            radar, 
                                            updateTimeoutValue,
                                            objectsListBlock) {

    if (!isMobile) {
        render(
            <MarkersToolsControl
                markersService={markersService}
                routesService={routesService}
                radar={radar}
                updateTimeoutValue={updateTimeoutValue}
                position={objectsListBlock.position}
            />,
            map.getContainer().parentElement
        );
    } else {
        render(
            <MarkersToolsControlMobile
                markersService={markersService}
                routesService={routesService}
                radar={radar}
                updateTimeoutValue={updateTimeoutValue}
                position={objectsListBlock.position}
            />,
            map.getContainer().parentElement
        );
    }
}